import { useEffect } from "react";

function updateMeta(records, attribute, key, content) {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  const created = !element;
  const previousContent = element?.getAttribute("content") || "";

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  records.push({ element, created, previousContent });
  element.setAttribute("content", content);
}

export default function ArticleSeo({
  title,
  description,
  canonical,
  image,
  type = "article",
  publishedAt,
  updatedAt,
  structuredData = [],
}) {
  const structuredDataJson = JSON.stringify(structuredData);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const previousTitle = document.title;
    const metaRecords = [];
    document.title = title;

    const canonicalElement =
      document.head.querySelector('link[rel="canonical"]') ||
      document.createElement("link");
    const createdCanonical = !canonicalElement.parentNode;
    const previousCanonical = canonicalElement.getAttribute("href");

    canonicalElement.setAttribute("rel", "canonical");
    canonicalElement.setAttribute("href", canonical);

    if (createdCanonical) {
      document.head.appendChild(canonicalElement);
    }

    updateMeta(metaRecords, "name", "description", description);
    updateMeta(metaRecords, "name", "robots", "index, follow");
    updateMeta(metaRecords, "property", "og:type", type);
    updateMeta(metaRecords, "property", "og:title", title);
    updateMeta(metaRecords, "property", "og:description", description);
    updateMeta(metaRecords, "property", "og:url", canonical);
    updateMeta(metaRecords, "property", "og:image", image);
    updateMeta(metaRecords, "property", "og:site_name", "Zaviramed");
    updateMeta(metaRecords, "property", "og:locale", "en_NG");
    updateMeta(metaRecords, "name", "twitter:card", "summary_large_image");
    updateMeta(metaRecords, "name", "twitter:title", title);
    updateMeta(metaRecords, "name", "twitter:description", description);
    updateMeta(metaRecords, "name", "twitter:image", image);

    if (publishedAt) {
      updateMeta(metaRecords, "property", "article:published_time", publishedAt);
    }

    if (updatedAt) {
      updateMeta(metaRecords, "property", "article:modified_time", updatedAt);
    }

    const scripts = JSON.parse(structuredDataJson).map((item, index) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-zaviramed-jsonld", `jsonld-${index}`);
      script.textContent = JSON.stringify(item);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      document.title = previousTitle;
      metaRecords.forEach(({ element, created, previousContent }) => {
        if (created) {
          element.remove();
        } else {
          element.setAttribute("content", previousContent);
        }
      });
      scripts.forEach((script) => script.remove());

      if (createdCanonical) {
        canonicalElement.remove();
      } else if (previousCanonical) {
        canonicalElement.setAttribute("href", previousCanonical);
      }
    };
  }, [
    title,
    description,
    canonical,
    image,
    type,
    publishedAt,
    updatedAt,
    structuredDataJson,
  ]);

  return null;
}
